import { ReportCategory } from '../types';
import { AddConstructionSchema, CreateConstructionSchema, FormReportSchema } from './validation';
import { AboutBuildingSchema } from './validation/about-building.validation';
import { DesigningSchema } from './validation/designing.validation';
import { FloorPlansSchema } from './validation/floor-plans.validation';
export var AboutBuildingConfig = {
    schema: AboutBuildingSchema,
    defaultValues: {
        name: '',
        region: '',
        buildingPurpose: '',
        buildingType: '',
        maxHeight: '',
        comfortClass: '',
        requirement: '',
        isFloorPlan: ReportCategory.Single,
        isBim: false,
    },
};
export var FloorPlansConfig = {
    schema: FloorPlansSchema,
    defaultValues: {
        floorPlanFile: null,
        floorPlanPdf: '',
    },
};
export var AddConstructionConfig = {
    schema: AddConstructionSchema,
    defaultValues: {
        cipher: '',
        constructionType: '',
        firstPlacementRoom: '',
        secondPlacementRoom: '',
    },
};
export var CreateConstructionConfig = {
    schema: CreateConstructionSchema,
    defaultValues: {
        name: '',
        constructionType: '',
        construction: '',
        firstPlacementRoom: '',
        secondPlacementRoom: '',
        area: '',
        width: '',
        length: '',
    },
};
export var DesigningConfig = {
    schema: DesigningSchema,
    defaultValues: {
        constructionTypeObject: {},
    },
};
export var FormReportConfig = {
    schema: FormReportSchema,
    defaultValues: {
        reportInfoId: '',
        customerName: '',
        objectDescription: '',
        creatorFullName: '',
        code: '',
        country: '',
        director: '',
        date: '',
        //logoUrl: z.string().min(1, 'Поле обязательно для заполнения'),
        floorDocumentsFlags: {},
    },
};
